import React from 'react';
import Loading from '../../loading';
import { STATS, TIPS } from './constants';
const Header = ({ stat = STATS.INIT }) => {
    return (React.createElement("div", { className: "pull-load-header-default" },
        [STATS.PULLING, STATS.ENOUGH, STATS.REFRESHED].indexOf(stat) !== -1 ? TIPS[stat] : '',
        stat === STATS.REFRESHING && React.createElement(Loading, { text: "\u5237\u65B0\u4E2D..." })));
};
export default Header;
